'use strict';

angular.module('amexReconciliationApp')
  .directive('truncatePercentage', function () {

    function link(scope, element, attrs, ngModel) {
      ngModel.$formatters.push(function (value) {
        return Math.floor(value * 100) / 100;
      });
    }

    return {
      restrict: 'A',
      require: 'ngModel',
      link: link
    };
  });


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/directives/truncatePercentage.js
// module id = 541
// module chunks = 0